<!--
 * @FileName: Do not edit
 * @Date: 2022-02-11 10:07:54
 * @LastEditors: dingzhaowei
 * @LastEditTime: 2024-04-08 16:36:44
 * @FilePath: \mobile-portal\src\App.vue
-->
<template>
  <div id="app">
  <!--显示的是当前路由地址所对应的内容-->
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  components: {},
};
</script>

<style lang="scss">
#app {
  background: #f3f6f8;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  height: 100vh;
  /* background: ; */
  color: #2c3e50;
  font-size: 1.2rem;
}
.biz-view{
  padding-bottom: 65px;
}
</style>
